import React, { useState, useEffect } from 'react';

import dayjs from 'dayjs';
import { APIROOT } from '../../Helpers/configs';

import { filterMethod } from '../../Helpers/helpers';
import { convertDate, convertDateForChrome } from '../../Helpers/dateHelpers';
import DatePicker from '../CommonComponents/DatePicker_v2';

import {
  gridStyle,
  modalStyle1024,
  modalStyle900,
  modalStyle600,
} from '../shared/commonStyle';

import { useNavigate } from 'react-router-dom';

import { DataGrid } from '@mui/x-data-grid';

// import CustomToolbar from '../../Design/customToolbar';
import CustomCustomerToolbar from './CustomSerialToolbar';
import {
  Box,
  Button,
  Modal,
  Grid,
  Divider,
  Typography,
  TextField,
  Autocomplete,
} from '@mui/material';

import {
  NoHeaderTableUpdate,
  CustomerConstants,
  getCabinetType,
  getData,
} from '../../Helpers/requests';
import { GetAuth } from '../../Auth/AuthProvider';

import SerialEditInfoCard from './SerialInfoEditCard';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function SerialNumberList() {
  // const fakeData = [...fakeSerialData];

  const navigateNew = useNavigate();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //Define state
  const [categoriesData, setCategoriesData] = useState([]);
  const [regionsData, setRegionsData] = useState([]);
  const [cabinetTypeList, setCabinetTypeList] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [forceUpdate] = useState(1);

  const [specialCategory] = useState([]);
  const [specialRegion] = useState([]);

  const [data, setData] = useState([]); //data displayed in datagrid
  const [page, setPage] = useState(0); //Active page of table - starts at 0!
  const [filter, setFilter] = useState([]); //Current applied filter modal
  const [sort, setSort] = useState([]); //Current applied sorting modal
  const [loading, setLoading] = useState(false); //Loading indicator - used by datagrid
  // const [activeRow, setActiveRow] = useState('NONE'); //Last row clicked - used in details (Detailbox) display
  const [pageSize, setPageSize] = useState(20); //Number of rows to display
  const [totalRows, setTotalRows] = useState(0); //Total Number of rows in set
  const [updateData, setUpdateData] = useState(0); //Increment to force update dataset
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [modalData, setModalData] = useState([]);
  const [editOrSave, setEditOrSave] = useState('saveMode');

  const [modalState, setModalState] = useState('notSet');
  const [filterModalEventFields, setFilterModalEventFields] = useState({
    storeName: '',
    storeCabinet: '',
    storeCategory: '',
    storeRegion: '',
    startDate: convertDateForChrome(Date.now()),
    endDate: convertDateForChrome(Date.now()),
  });
  console.log(filterModalEventFields);

  const [filterOpen, setFilterOpen] = useState(false);
  const handleFilterOpen = () => setFilterOpen(true);
  const handleFilterClose = () => setFilterOpen(false);

  const [fullFilterStoreName, setFullFilterStoreName] = useState();
  const [fullFilterCabinetType, setFullFilterCabinetType] = useState();
  const [fullFilterCategory, setFullFilterCategory] = useState();
  const [fullFilterRegion, setFullFilterRegion] = useState();
  const [rangeFilterDateStart, setRangeFilterDateStart] = useState();
  const [rangeFilterDateEnd, setRangeFilterDateEnd] = useState();

  function diffInYears(endDate, startDate) {
    var diff = (endDate.getTime() - startDate.getTime()) / 1000;
    diff /= 60 * 60 * 24;
    let years = diff / 365.25;
    return years.toFixed(2);
  }

  console.log('DATE NOW', convertDate(Date.now(), 0, 10));
  const handleAutoComplete = (event, newValue) => {
    // console.log(event);
    console.log('Value:', newValue);

    switch (event) {
      case 'fullName':
        setFilterModalEventFields({
          ...filterModalEventFields,
          storeName: newValue,
        });
        break;
      case 'fullCabinet':
        setFilterModalEventFields({
          ...filterModalEventFields,
          storeCabinet: newValue,
        });
        break;
      case 'fullCategory':
        setFilterModalEventFields({
          ...filterModalEventFields,
          storeCategory: newValue,
        });
        break;
      case 'fullRegion':
        setFilterModalEventFields({
          ...filterModalEventFields,
          storeRegion: newValue,
        });
        break;
      case 'rangeStart':
        setFilterModalEventFields({
          ...filterModalEventFields,
          startDate: newValue,
          // startDate: handelDate(newValue, '00:00:01'),
        });
        break;
      case 'rangeEnd':
        setFilterModalEventFields({
          ...filterModalEventFields,
          endDate: newValue,
          // endDate: handelDate(newValue, '23:59:59'),
        });
        break;
      default:
        break;
    }
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setFullFilterStoreName(filterModalEventFields.storeName);
    setFullFilterCabinetType(filterModalEventFields.storeCabinet.name);
    setFullFilterCategory(filterModalEventFields.storeCategory.id);
    setFullFilterRegion(filterModalEventFields.storeRegion.name);
    setRangeFilterDateStart(filterModalEventFields.startDate);
    setRangeFilterDateEnd(filterModalEventFields.endDate);

    setModalState('isSet');
    handleFilterClose();
  };

  const clearFilterEntries = (e) => {
    e.preventDefault();
    setModalState('notSet');
    setFilterModalEventFields({
      ...filterModalEventFields,
      storeName: '',
      storeCabinet: '',
      storeCategory: '',
      storeRegion: '',
      startDate: convertDateForChrome(Date.now()),
      endDate: convertDateForChrome(Date.now()),
    });
    setFullFilterStoreName('');
    setFullFilterCabinetType('');
    setFullFilterCategory('');
    setFullFilterRegion('');
    setRangeFilterDateStart(null);
    setRangeFilterDateEnd(null);

    // handleFilterClose();
  };

  const filterCabinetOptions = filterMethod;
  const filterCategoriesOptions = filterMethod;
  const filterRegionsOptions = filterMethod;

  const checkInWarrantee = (params) => {
    let warrantee = params.getValue(params.id, 'warranty_period');
    let age = params.getValue(params.id, 'install_Age');
    let inOrOutWarrante =
      warrantee >= age ? 'In Warrantee' : 'Out Of Warrantee';
    return inOrOutWarrante;
  };

  useEffect(() => {
    getData(`users`, {
      pagereq: {
        filter: {
          fullfilter: [
            {
              field: 'name',
              search: '',
              strict: false,
            },
          ],
        },
      },
    }).then((data) => {
      setUsersData(data.data.value);
    });
  }, [forceUpdate]);

  useEffect(() => {
    getCabinetType({
      resource: `/api/warranties`,
      setCabinetTypesFunc: setCabinetTypeList,
      logout,
    });
  }, [logout]);

  useEffect(() => {
    CustomerConstants({
      resource: `/api/constants/customer`,
      setCategoriesFunc: setCategoriesData,
      setRegionsFunc: setRegionsData,
      setAsset_compFunc: () => {},
      setLoadingFunc: false,
      showNotification: enqNotification,
      logout,
    });
  }, [enqNotification, logout]);

  useEffect(() => {
    NoHeaderTableUpdate(
      {
        resource: `/api/serialnumbers`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
        fullFilterStoreName: fullFilterStoreName,
        fullFilterCabinetType: fullFilterCabinetType,
        fullFilterCategory: fullFilterCategory,
        fullFilterRegion: fullFilterRegion,
        rangeFilterDateStart: rangeFilterDateStart,
        rangeFilterDateEnd: rangeFilterDateEnd,
      },
      'serial'
    );
  }, [
    page,
    pageSize,
    sort,
    filter,
    updateData,
    enqNotification,
    logout,
    fullFilterStoreName,
    fullFilterCabinetType,
    fullFilterCategory,
    fullFilterRegion,
    rangeFilterDateStart,
    rangeFilterDateEnd,
  ]);

  async function getCustomerbyID(searchRegion, searchCategory, searchName) {
    let JWT = localStorage.getItem('JWT_Key');
    let headers = {
      'content-type': 'application/JSON',
    };

    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    // console.log(
    //   `%cSEARCH REGION: ${searchRegion}`,
    //   'color: yellow, font-size:1.2em'
    // );

    let body = {
      pagereq: {
        filter: {
          fullfilter: [
            {
              field: 'special_region',
              search: searchRegion,
              strict: true,
            },
            {
              field: 'special_category',
              search: searchCategory,
              // search: 'FEF791FC-1986-4ACB-B013-781551FC4550',
              strict: true,
            },
            {
              field: 'name',
              search: searchName,
              strict: false,
            },
          ],
        },
      },
    };

    const request = new Request(`${APIROOT}/api/customersv2`, {
      method: 'post',
      headers,
      body: JSON.stringify(body),
    });
    const response = await fetch(request);

    const data = response.json();
    return data;
  }

  useEffect(() => {
    getCustomerbyID(specialRegion, specialCategory).then((data) => {
      setCustomerData(data.data.value);
    });
  }, [forceUpdate, specialRegion, specialCategory]);

  const getMyRowData = (modalRowData) => {
    let settingData = modalRowData;

    setModalData(settingData);
  };

  const handelDate = (date, subVal) => {
    const inDate = date;
    // let outDate = inDate.substring(0, inDate.lastIndexOf('T') + 1);
    // outDate = outDate + subVal;
    // console.log(`Date: ${date} ${subVal} \nOutDate:`);
    return `${date} ${subVal}`;
  };
  //Configure columns for datagrid
  const definedColumns = [
    {
      field: 'serial_number',
      headerName: 'Serial Number',
      minWidth: 180,
      flex: 1,
      editable: false,
    },
    {
      field: 'cabinet_name',
      headerName: 'Cabinet Type',
      minWidth: 180,
      flex: 1,
      editable: false,
    },
    {
      field: 'store_category_name',
      headerName: 'Store Category',
      minWidth: 180,
      flex: 1,
      editable: false,
    },
    {
      field: 'store_name',
      headerName: 'Customer Name',
      minWidth: 180,
      flex: 1,
      editable: false,
    },
    {
      field: 'store_region_name',
      headerName: 'Region',
      minWidth: 180,
      flex: 1,
      editable: false,
    },
    {
      field: 'install_date',
      headerName: 'Installation Date',
      minWidth: 150,
      flex: 1,
      editable: false,
      valueGetter: ({ value }) =>
        new Date(value).toLocaleString('en-GB').slice(0, 10),
      // valueGetter: ({ value }) => new Date(value).toString(),
    },
    {
      field: 'warranty_period',
      headerName: 'Warrantee Period (years)',
      minWidth: 190,
      flex: 1,
      editable: false,
      align: 'center',
      valueGetter: ({ value }) =>
        value === undefined ? 1.0 : parseFloat(value),
    },

    {
      field: 'install_Age',
      headerName: 'Age (years)',
      minWidth: 100,
      flex: 1,
      editable: false,
      align: 'center',
      valueGetter: (props) =>
        diffInYears(new Date(), new Date(props.row.install_date)),
      // valueGetter: getWarranteeAge,
    },
    {
      field: 'tmp_warrantee',
      headerName: 'Warrantee Status',
      minWidth: 150,
      flex: 1,
      editable: false,
      valueGetter: checkInWarrantee,
    },
    //Custom "Actions" column - props.value is field value (id in this case)
    {
      field: 'id',
      headerName: 'Actions',
      align: 'left',
      minWidth: 200,
      flex: 1,
      sortable: false,

      renderCell: (props) => (
        <>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              handleOpen();
              getMyRowData(props.row);
              setEditOrSave('editMode');
            }}
          >
            Edit
          </Button>
          <Button
            sx={{ marginLeft: '5px' }}
            variant='outlined'
            size='small'
            onClick={() => {
              getMyRowData(props.row);
              navigateNew(`/serial/serial_history`, {
                replace: true,
                state: props.row,
              });
            }}
          >
            History
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ minHeight: '79vh', maxWidth: '100%' }}>
      {/* <center> */}
      <div style={{ height: '79vh', maxWidth: '100%', textAlign: 'center' }}>
        {/*Configure datagrid */}
        <DataGrid
          sx={gridStyle}
          rows={data}
          rowCount={totalRows}
          loading={loading}
          pagination
          sortingMode='server'
          filterMode='server'
          onSortModelChange={(model) => {
            setPage(0);
            setSort(model);
          }}
          onFilterModelChange={(model) => {
            setPage(0);
            setFilter(model.quickFilterValues);
          }}
          page={page}
          pageSize={pageSize}
          paginationMode='server'
          onPageChange={(newPage) => {
            setPage(newPage);
          }}
          onPageSizeChange={(newPageSize) => {
            setPage(0);
            setPageSize(newPageSize);
          }}
          columns={definedColumns}
          onRowClick={(params) => {
            // console.log(page);
          }}
          onRowDoubleClick={(params) => {
            handleOpen();
            getMyRowData(params.row);
            setEditOrSave('editMode');
          }}
          rowsPerPageOptions={[20, 50, 100]}
          components={{ Toolbar: CustomCustomerToolbar }}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          componentsProps={{
            toolbar: {
              updateOnclick: () => {
                setUpdateData((i) => i + 1);
              },
              filterOnClick: () => {
                handleFilterOpen();
              },
              modalState: modalState,
            },
          }}
        />
      </div>
      {/* <div id='test' style={{ height: 200, width: '80%' }}>
          <br />
          <br />
          <Detailbox rowData={activeRow} />
          <br />
        </div> */}
      {/* </center> */}
      <Button
        sx={{ margin: '15px', float: 'right' }}
        variant='contained'
        // size='small'
        onClick={() => {
          let newDate = new Date().toISOString().split('T')[0];
          getMyRowData({
            serial_number: null,
            store_id: customerData[0].id,
            install_date: newDate,
            warranty_period: '0',
            installer_id: usersData[0].id,
            cabinet_name: cabinetTypeList[0].name,
            cabinet_type_id: cabinetTypeList[0].id,
            store_name: '',
            store_category_guid: categoriesData[0].id,
            store_category_name: '',
            store_region_guid: regionsData[0].id,
            store_region_name: '',
            installer_name: '',
          });
          handleOpen();
          setEditOrSave('saveMode');
        }}
      >
        Add New
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle600} md={modalStyle900} lg={modalStyle1024}>
          <SerialEditInfoCard
            modalData={modalData}
            closeModel={handleClose}
            modalMode={editOrSave}
          />
        </Box>
      </Modal>
      <Modal
        open={filterOpen}
        onClose={handleFilterClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle}>
          <form>
            <Grid
              container
              rowSpacing={0}
              columnSpacing={{ xs: 1, sm: 1, md: 1 }}
              rowGap={{ xs: 1, sm: 1, md: 1 }}
              style={{
                background: '#84a1bc91',
                padding: '5px 10px 5px 5px',
                borderRadius: '5px',
              }}
            >
              <Grid item xs={12} md={12}>
                <Typography variant='h5' sx={{ height: 40 }}>
                  Filter
                </Typography>
                <Divider />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Customer Name:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name='fullFilterName'
                  id='fullFilterName'
                  size='small'
                  sx={{
                    width: '100%',
                    background: '#fff',
                    borderRadius: '5px',
                  }}
                  // onChange={handleChange}
                  onChange={(event, newValue) =>
                    handleAutoComplete('fullName', event.target.value)
                  }
                  value={filterModalEventFields.storeName}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Cabinet Type:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  sx={{
                    width: '100%',
                    background: '#ffffff',
                    padding: 0,
                  }}
                  name='cabinetType'
                  key='cabinetType'
                  id='cabinetType'
                  variant='standard'
                  size='small'
                  value={filterModalEventFields.storeCabinet}
                  // defaultValue={filterModalEventFields.storeCabinet || ''}
                  // onChange={setCabinet}
                  onChange={(event, newValue) =>
                    handleAutoComplete('fullCabinet', newValue)
                  }
                  disablePortal
                  options={cabinetTypeList}
                  filterOptions={filterCabinetOptions}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => <TextField {...params} />}
                  isOptionEqualToValue={(option, value) => {
                    return option.id === value.id ? true : false;
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Store Category:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  sx={{
                    width: '100%',
                    background: '#fff',
                    padding: 0,
                  }}
                  name='fullFilterCategory'
                  id='fullFilterCategory'
                  variant='standard'
                  size='small'
                  value={filterModalEventFields.storeCategory}
                  // onChange={getNewCustomerFromCategory}
                  onChange={(event, newValue) =>
                    handleAutoComplete('fullCategory', newValue)
                  }
                  disablePortal
                  options={categoriesData}
                  filterOptions={filterCategoriesOptions}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => <TextField {...params} />}
                  isOptionEqualToValue={(option, value) => {
                    return option.id === value.id ? true : false;
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Store Region:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  sx={{
                    width: '100%',
                    background: '#fff',
                    borderRadius: '5px',
                    padding: 0,
                  }}
                  name='fullFilterRegion'
                  id='fullFilterRegion'
                  variant='standard'
                  size='small'
                  value={filterModalEventFields.storeRegion}
                  // onChange={getNewCustomerFromRegion}
                  onChange={(event, newValue) =>
                    handleAutoComplete('fullRegion', newValue)
                  }
                  disablePortal
                  options={regionsData}
                  filterOptions={filterRegionsOptions}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => <TextField {...params} />}
                  isOptionEqualToValue={(option, value) => {
                    return option.id === value.id ? true : false;
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Installed Period:
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Start:
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <DatePicker
                  // dateLabel='End Date'
                  getDate={(data) => handleAutoComplete('rangeStart', data)}
                  // value={filterModalEventFields.startDate}
                  // value={dayjs(filterModalEventFields.startDate)}
                  defaultDate={
                    filterModalEventFields.startDate
                      ? filterModalEventFields.startDate
                      : Date.now()
                  }
                ></DatePicker>
                {/* <TextField
                  id='startDate'
                  key='startDate'
                  name='startDate'
                  type='date'
                  // inputFormat='DD/MM/YYYY'
                  // format='DD/MM/YYYY'
                  onChange={(event, newValue) => {
                    handleAutoComplete('rangeStart', event.target.value);
                  }}
                  dateValue={filterModalEventFields.startDate}
                  sx={{
                    width: '100%',
                    background: '#ffffff',
                    height: '40px',
                    // format: 'DD/MM/YYYY',
                    padding: '5px 10px',
                    borderRadius: '5px',
                  }}
                  variant='standard'
                  InputLabelProps={{
                    shrink: true,
                  }}
                /> */}
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  End:
                </Typography>
              </Grid>

              <Grid item xs={6} md={3}>
                <DatePicker
                  // dateLabel='End Date'
                  getDate={(data) =>
                    // handleAutoComplete('rangeEnd', handelDate(data, '23:59:59'))
                    handleAutoComplete('rangeEnd', data)
                  }
                  defaultDate={
                    filterModalEventFields.endDate
                      ? filterModalEventFields.endDate
                      : Date.now()
                  }
                ></DatePicker>
                {/* <TextField
                  id='endDate'
                  key='endDate'
                  name='endDate'
                  type='date'
                  // onChange={handleChange}
                  onChange={(event, newValue) =>
                    handleAutoComplete('rangeEnd', event.target.value)
                  }
                  value={filterModalEventFields.endDate}
                  sx={{
                    width: '100%',
                    background: '#ffffff',
                    height: '40px',

                    padding: '5px 10px',
                    borderRadius: '5px',
                  }}
                  variant='standard'
                  InputLabelProps={{
                    shrink: true,
                  }}
                /> */}
              </Grid>
            </Grid>
            <Button
              sx={{ margin: '20px 0 0 20px', float: 'right' }}
              variant='outlined'
              onClick={handleFilterClose}
            >
              Close
            </Button>
            <Button
              sx={{ margin: '20px 0 0 20px', float: 'right' }}
              variant='contained'
              type='submit'
              color='success'
              className='btn btn-primary'
              onClick={clearFilterEntries}
            >
              Clear Filter
            </Button>
            <Button
              sx={{ margin: '20px 0 0 0', float: 'right' }}
              variant='contained'
              type='submit'
              className='btn btn-primary'
              onClick={handleFilterSubmit}
              disabled={modalState === 'isSet' ? true : false}
            >
              Set Filter
            </Button>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
